import ajaxRequest from './ajax'
import qs from "qs"

//创建一个活动
export const create_or_update_event = params => {
    return ajaxRequest.post("event/create_or_update_event", params)
}

// 获取活动阶段
export const get_event_stage_code_master_data = params => {
  return ajaxRequest.get("/event/get_event_stage_code_master_data")
}

//上传活动的封面
export const upload_event_home_poster = params => {
    return ajaxRequest.post("event/upload_event_home_poster", params)
}

//下载活动参会人的列表
export const get_upload_event_attendee_template = () => {
    return ajaxRequest.get("event/get_upload_event_attendee_template",{ responseType: 'blob' })
}

//获取活动参会人的列表
export const get_event_attendee_list = params => {
    return ajaxRequest.post("event/get_event_attendee_list", params);
}

export const list_users_join_event = (body, query) => {
    return ajaxRequest.post("event/list_users_join_event?" + qs.stringify(query), body)
}

//移除参会人
export const remove_event_attendee = params => {
    return ajaxRequest.post("event/remove_event_attendee?" + qs.stringify(params));
}

//新增参会人
export const add_event_attendee = params => {
    return ajaxRequest.post("event/add_event_attendee", params);
}

//更新参会人
export const update_event_attendee = params => {
    return ajaxRequest.post("event/update_event_attendee", params)
}

//开始一个活动
export const active_event = params => {
    return ajaxRequest.get("event/active_event?" + qs.stringify(params))
}


//管理员获取活动列表
export const list_event_admin = () => {
    return ajaxRequest.get("event/list_event_admin");
}

//列出当前的活动
export const list_event = () => {
    return ajaxRequest.get("event/list_event")
}

export const get_event = params => {
    return ajaxRequest.get("event/get_event?" + qs.stringify(params))
}

export const get_event_admin = params => {
    return ajaxRequest.get("event/get_event_admin?" + qs.stringify(params))
}

//新增讲者
export const add_event_speaker = params => {
    return ajaxRequest.post("event/add_event_speaker", params);
}

//直接邀请讲者
export const add_event_speaker_by_invitation = params => {
    return ajaxRequest.post("event/add_event_speaker_by_invitation", params)
}

//删除讲者
export const remove_event_speaker = params => {
    return ajaxRequest.post("event/remove_event_speaker?" + qs.stringify(params));
}

//新增助理
export const add_event_assistant = params => {
  return ajaxRequest.post("event/add_event_assistant", params);
}

//直接邀请助理（通过手机号/邮箱等添加助理）
export const add_event_assistant_by_invitation = params => {
  return ajaxRequest.post("event/add_event_assistant_by_invitation", params);
}

//删除助理
export const remove_event_assistant = params => {
  return ajaxRequest.post("event/remove_event_assistant?" + qs.stringify(params));
}

// 获取 event 的 dashboard
export const load_event_dashboard = params => {
    // return ajaxRequest.get("/report/load_event_dashboard?event_id=1&report_type=attendee_login_by_date")
    return ajaxRequest.get("report/load_event_dashboard?" + qs.stringify(params))
}

//api/session/get_online_users_by_session_ids
export const get_online_users_by_session_ids = params => {
  return ajaxRequest.post("session/get_online_users_by_session_ids", params);
}

//api/session/get_online_users_by_session
export const get_online_users_by_session = params => {
  return ajaxRequest.post("session/get_online_users_by_session", params);
}

//报表一键导出
export const download_attendee_event_report = params => {
  return ajaxRequest.get("report/download_attendee_event_report?" + qs.stringify(params), {responseType: "blob"})
}
export const download_attendee_session_report = params => {
  return ajaxRequest.get("report/download_attendee_session_report?" + qs.stringify(params), {responseType: "blob"})
}

//审批attendee
export const approve_or_reject_users_join_event = (body, params) => {
    return ajaxRequest.post("event/approve_or_reject_users_join_event?" + qs.stringify(params), body)
}

//下载审批的列表
export const download_users_join_event = params => {
    return ajaxRequest.get("event/download_users_join_event?" + qs.stringify(params), {responseType: "blob"})
}

//上传审批的列表
export const upload_approve_or_reject_users_join_event = (params, body) => {
    return ajaxRequest.post("event/upload_approve_or_reject_users_join_event?" + qs.stringify(params), body, { responseType: "blob", headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }  })
}

//删除活动
export const delete_event = params => {
    return ajaxRequest.post("event/delete_event?" + qs.stringify(params))
}

//判断该用户是否为指定活动的拥有者
export const check_is_event_owner = params => {
    return ajaxRequest.post("event/check_is_event_owner?" + qs.stringify(params))
}

export const check_is_event_main_owner = params => {
    return ajaxRequest.post("event/check_is_event_main_owner?" + qs.stringify(params))
}

//删除活动管理员
export const delete_event_admin = params => {
    return ajaxRequest.post("event/delete_event_admin?" + qs.stringify(params))
}

//新增活动管理员
export const add_event_admin = params => {
    return ajaxRequest.post("event/add_event_admin", params)
}

//通过名字和邮箱邀请event管理员
export const add_event_admin_by_invitation = params => {
    return ajaxRequest.post("event/add_event_admin_by_invitation", params)
}

//获取直播频道的列表
export const get_channel_list_by_event = params => {
    return ajaxRequest.get("event/get_channel_list_by_event?" + qs.stringify(params))
}

//删除直播频道
export const delete_channel = params => {
    return ajaxRequest.post("event/delete_channel?" + qs.stringify(params))
}

//新增partner contact
export const add_partner_contacter = params => {
    return ajaxRequest.post("event/add_partner_contacter", params)
}

//删除partner contact
export const delete_partner_contact = params => {
    return ajaxRequest.post("event/delete_partner_contact?" + qs.stringify(params))
}

//邀请新的partner contact
export const add_partner_contacter_by_invitation = params => {
    return ajaxRequest.post("event/add_partner_contacter_by_invitation", params)
}

//添加频道的播音员
export const add_channel_owner = params => {
    return ajaxRequest.get("event/add_channel_owner?" + qs.stringify(params))
}

//kls20-web.meetzen.cn/api/dashboard/attendee_event_dataset?event_id=337
export const attendee_event_dataset = params => {
    return ajaxRequest.get("dashboard/attendee_event_dataset?" + qs.stringify(params))
}

//kls20-web.meetzen.cn/api/dashboard/attendee_session_dataset?event_id=337
export const attendee_session_dataset = params => {
    return ajaxRequest.get("dashboard/attendee_session_dataset?" + qs.stringify(params))
}

export const send_switch_platform_notification_by_event = params => {
    return ajaxRequest.post("event/send_switch_platform_notification_by_event", params)
}
// 1.check_event 发起检查 / 轮询
// 2.get_event_check_list 获取检查结果
// 开始检查
export const check_event= params => {
  return ajaxRequest.get("/event/check_event?"+ qs.stringify(params))
}
// 获取检查结果
export const get_event_check_list= params => {
  return ajaxRequest.get("/event/get_event_check_list?"+ qs.stringify(params))
}
// 标记检查项
export const fix_event_issue = params=>{
  return ajaxRequest.post("/event/fix_event_issue?"+ qs.stringify(params))
}
// 获取活动基本信息
export const get_event_basic_info = params => {
  return ajaxRequest.get("event/get_event_basic_info?" + qs.stringify(params));
}

// 获取当前身份信息
export const get_event_role = params => {
  return ajaxRequest.get("event/get_event_role?" + qs.stringify(params))
}

// 上传参会人excel
export const upload_event_attendee = (params,body) => {
  return ajaxRequest.post("event/upload_event_attendeev2?"+qs.stringify(params),body,{ responseType: 'blob', headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' } })
}
// 下载所有参会人
export const download_event_attendee = params => {
  return ajaxRequest.get("event/download_event_attendee?"+qs.stringify(params),{ responseType: 'blob' })
}

// 删除活动banner
export const delete_event_home_poster = params => {
  return ajaxRequest.post("event/delete_event_home_poster?"+qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/event.js